import { render } from "./StaticActions.vue?vue&type=template&id=63c972fa&ts=true"
import script from "./StaticActions.vue?vue&type=script&lang=ts"
export * from "./StaticActions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__